import React, { PropsWithChildren } from "react"
import clsx from "clsx"
import { Icon } from "@silversea-ssc/ui-components-react"
import styles from "./Tag.module.scss"

type Props = {
    className?: string
}

const Tag: React.FC<PropsWithChildren<Props>> = ({ children, className }) => {
    return (
        <div className={clsx(styles.root, className)}>
            <Icon className={styles.icon} name="check" padding={false} size="1x" />
            <span className={styles.content}>{children}</span>
        </div>
    )
}

export default Tag
